import { render, staticRenderFns } from "./ClientRoleAdd.vue?vue&type=template&id=53e1ee1a&scoped=true&"
import script from "./ClientRoleAdd.vue?vue&type=script&lang=js&"
export * from "./ClientRoleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e1ee1a",
  null
  
)

export default component.exports